module.exports = __WEBPACK_EXTERNAL_MODULE_29__;


//////////////////
// WEBPACK FOOTER
// external "@korzio/djv-draft-04"
// module id = 29
// module chunks = 0